import React from 'react';

import type { Order } from '@src/domains/orders';
import type { SaleChange } from '@src/domains/sales';
import { ReservationCard } from '@src/features/sale-items';

import { ConfirmedOrderHeader } from '../ConfirmedOrderHeader';
import { useConfirmedOrder } from '../../hooks/useConfirmedOrder';
import { ConfirmedOrderRoot } from '../../styles';

export type ConfirmedOrderCardProps = {
  order: Order;
  onSaleChangeCheckout?: (saleChange: SaleChange) => void;
};

export const ConfirmedOrderCard = (props: ConfirmedOrderCardProps) => {
  const { order, onSaleChangeCheckout } = props;
  const confirmed = useConfirmedOrder(order);

  return (
    <ConfirmedOrderRoot data-testid='confirmed-order-card'>
      <ConfirmedOrderHeader
        showsDownload={confirmed.showsOrderDownload}
        isDownloadBlocked={confirmed.isOrderDownloadBlocked}
        isDownloading={confirmed.isDownloadingOrder}
        onDownload={confirmed.downloadOrder}
      />

      {confirmed.reservations.map((reservation) => (
        <ReservationCard
          key={reservation.saleItem.id}
          orderId={order.id}
          reservationId={reservation.reservationId}
          saleItem={reservation.saleItem}
          isPackageItem={reservation.isPackageItem}
          hasMultipleVouchers={confirmed.hasMultipleVouchers}
          onSaleChangeCheckout={onSaleChangeCheckout}
        />
      ))}
    </ConfirmedOrderRoot>
  );
};

export default ConfirmedOrderCard;
